import React from 'react'
import Link from 'next/link'
import { cn } from '@/hooks/utils'
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: 'primary' | 'secondary' | 'outline' | 'ghost'
    href?: string
    size?: 'sm' | 'md' | 'lg'
    target?: string
    rel?: string
}

export const Button = ({
    className,
    variant = 'primary',
    size = 'md',
    href,
    children,
    ...props
}: ButtonProps) => {
    const baseStyles =
        'cursor-pointer inline-flex items-center justify-center rounded-full font-medium transition-all duration-200 focus:outline-none  disabled:opacity-50 disabled:pointer-events-none  font-sans'

    const variants = {
        primary:
            'bg-[#7c38f6] text-white hover:bg-[#6b2ee0]  border border-transparent',
        secondary: 'bg-blue-100 text-blue-700 hover:bg-blue-200',
        outline: 'border border-[#E0E0E0] text-white hover:bg-white/10',
        ghost: 'hover:bg-slate-100 text-slate-600',
    }

    const sizes = {
        sm: 'h-8 px-4 text-xs',
        md: 'h-[40px] px-6 py-2 text-sm leading-5',
        lg: 'h-12 px-8 text-lg',
    }

    const classes = cn(baseStyles, variants[variant], sizes[size], className)

    if (href) {
        return (
            <Link href={href} className={classes} onClick={props.onClick as any} target={props.target} rel={props.rel}>
                {children}
            </Link>
        )
    }

    return (
        <button className={classes} {...props}>
            {children}
        </button>
    )
}
